import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
//import Grid from '@material-ui/core/Grid';
//import { fonts } from '../../styles/variables';
import { fontSizes, fontFamily } from '../../styles/variables';

const backgrounImage = require('../../images/features_main.png');
const secondImage = require('../../images/secondpageimage.png');
const useStyles = makeStyles(() =>
  createStyles({
    
    root: {
    //   flexGrow: 1,
    padding: 5,
    margin: 0,
      backgroundImage: `url(${backgrounImage})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      height: '35rem',
      objectFit:'fill',
      backgroundOrigin:'content-box',
      backgroundAttachment:'fixed',
      '@media only screen and (max-width: 959px)': {
        height: '38rem',
        // maxWidth: "62%",
      },
    },
    root2: {
      flexGrow: 1,
      margin: 0,
      padding: 0,
      height: '100%',
      backgroundColor:'#F7F7F7'
    },
    grid: {
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      top: '0.3125rem',
      left: 0,
      right: 0,
      bottom: 0,
    },
    secondImage:{
      width:'50%',
      top:'2em',
      position:'relative',
      justifyContent:'center',
      alignContent:'center',
      backgroundAttachment:'fixed',
      backgroundPosition:'center',
      '@media only screen and (max-width: 959px)': {
          display:'none'
          // maxWidth: "62%",
      },
    },
    secondImageDiv:{
      marginTop:'-20em',
      padding:0,
      display:'flex',
      justifyContent:'center',
      alignContent:'center',
      '@media only screen and (max-width: 959px)': {
  
      },
    },
    HeaderDiv:{
      fontFamily: fontFamily.poppins,
      textAlign:'center',
      display:'flex',
      fontSize: fontSizes.lg.large,
      justifyContent:'center',
      flexDirection:'row',
      paddingTop:70,
      paddingBottom:20,
      '@media only screen and (max-width: 959px)': {
        display:'flex',
        justifyContent:'center',
        fontSize:fontSizes.lg.regular,
        paddingTop:40,
      }, 
    },
    HeaderTextRed:{
      fontFamily:fontFamily.poppins,
      // fontSize:'3rem',
      textAlign:'left',
      color:'#ED5565',
      fontWeight:'bold' ,
      '@media only screen and (max-width: 959px)': {
        textAlign:'initial',
        fontSize: fontSizes.lg.regular,
        // maxWidth: "62%",
      }, 
    },
    HeaderTextWhite:{
      fontFamily:fontFamily.poppins,
      // fontSize:'3rem',
      textAlign:'right',
      color:'white',
      fontWeight:'bold',
      '@media only screen and (max-width: 959px)': {
        textAlign:'initial',
        fontSize: fontSizes.lg.regular,
        // maxWidth: "62%",
      }, 
    },
    description:{
      fontFamily:fontFamily.poppins,
      fontWeight:'lighter',
      color:'#B7B7B7',
      fontSize: fontSizes.md.regular,
      paddingLeft:'20em',
      paddingRight:'20em',
      display:'flex',
      textAlign:'center',
      justifyContent:'center',
      flexDirection:'column',
      lineHeight:2,
      '@media only screen and (max-width: 959px)': {
        paddingLeft:'0em',
        paddingRight:'0em',
      }, 
    }
  })
);
function Features(props: any){
  const classes = useStyles();

  return (
      <div className={classes.root2} >
        <div className={classes.root}>
          <div className={classes.HeaderDiv}>
            <div className={classes.HeaderTextRed}>Record </div>
            <div className={classes.HeaderTextWhite}>  , Save and Share</div>
          </div>
          {props.description ?
           <div className={classes.description}>{props.description}</div>
           :
           <div className={classes.description}>200,000 successful reordings every month. Extend your information sharing <br/>success with our easy to use online screen recorder</div>

          }
         
         
        </div>
        <div className={classes.secondImageDiv}>
            <img src={secondImage} alt="secondimage" className={classes.secondImage}/>
          </div>
      </div>
  );
};
export default Features;